
require('./bootstrap');


// Here is the popup effect for images
require('magnific-popup')

let caption = window.$('a.mpopup, .wp-caption > a');
caption.length && caption.magnificPopup({
  type: 'image',
  closeOnContentClick: true,
  image: {
    verticalFit: true,
    titleSrc: function (item) {
      return item.el.siblings('.wp-caption-text').text();
    }
  }
});

// Here is the popup effect for a gallery
let gallery = window.$('.popup-gallery');
gallery.length && gallery.magnificPopup({
  delegate: 'a',
  type: 'image',
  tLoading: 'Loading image #%curr%...',
  mainClass: 'mfp-img-mobile',
  gallery: {
    enabled: true,
    navigateByImgClick: true,
    preload: [0,1] // Will preload 0 - before current, and 1 after the current image
  },
  image: {
    tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
    titleSrc: function(item) {
      return item.el.attr('title');
    }
  }
});


// This is for the mobile menu
import Slideout from 'slideout/dist/slideout';
var mobile = new Slideout({
  'panel': document.getElementById('app'),
  'menu': document.getElementById('mobile-nav'),
  'padding': 256,
  'tolerance': 70,
  'side': 'right'
});

// This allows the user to click on the overlay and close the mobile menu
var appOverlay = document.getElementById('app-overlay');
document.querySelector('.toggle-nav').addEventListener('click', function() {
  mobile.toggle();
  appOverlay.style.display = "block";
});
appOverlay.addEventListener('click', function() {
  appOverlay.style.display = "none";
  mobile.toggle();
});

// This is the go up button
window.$(document).ready(function($){
  var speed = 550;
	$('.go-up').on('click', function(e){
    e.preventDefault();
		$('html, body').animate({scrollTop:0}, speed);
		return false;
	});
});

// Some old code probably lets touch work on ipads
window.$(($) => {

  // cache elements
  const $nav = $('#main-nav-ul');

  // Add drop menu touch events
  $nav.find('.menu-item-has-children > a').on('touchstart', function() {
    const $this = $(this);
    const href = $this.attr('href');

    // Go to the link if there is one
    if ((href !== '#') && $this.parent().hasClass('touch-opened')) {
      document.location = href;
      return true;
    }
    $this.parent().addClass('touch-opened');
    return false;
  });
});



// WEBPACK FOOTER //
// ./assets/js/app.js